import { createDeferredI18n } from "#/shared/composables/useI18n";

// Mirrors `frontend.components` in config/locales/frontend.en.yml. Shared by the display
// primitives, so one bundle fetch covers the page however many of them it renders.
//
// The bundle fetch resolves even when the request fails, and an unresolved key renders as the key
// itself, so these seed the instance: a failed fetch degrades to English rather than announcing
// `chip_remove` to a screen reader. The fetched bundle overwrites all of it, including a client's
// own overrides.
const FALLBACK_MESSAGES = {
  chip_remove: "Remove {label}",
  modal_close: "Close",
  table_empty: "No data",
  table_sort_by: "Sort by {label}",
  table_per_page: "Results per Page:",
  table_pagination: "Pagination",
  table_first_page: "First",
  table_previous_page: "Previous",
  table_next_page: "Next",
  table_last_page: "Last",
  table_go_to_page: "Go to page {page}",
  table_page_status: "Page {page} of {pages}",
};

export const { i18n, ready: whenComponentsI18nReady } = createDeferredI18n({ key: "components" });

i18n.global.setLocaleMessage(i18n.global.locale.value, FALLBACK_MESSAGES);

/**
 * Translates a shared component string. Keys are relative to `frontend.components`, which the i18n
 * endpoint serves as the message root, and resolve per client through that client's own locale
 * files.
 *
 * @param {String} key
 * @param {Object} [values] - Values for the named placeholders of the message.
 * @returns {String}
 */
export function t(key, values) {
  return values ? i18n.global.t(key, values) : i18n.global.t(key);
}
